














































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLine } from '@fortawesome/free-brands-svg-icons/faLine';

import bButton from 'bootstrap-vue/es/components/button/button';
import bForm from 'bootstrap-vue/es/components/form/form';
import bInput from 'bootstrap-vue/es/components/form-input/form-input';
import bImg from 'bootstrap-vue/es/components/image/img';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bLink from 'bootstrap-vue/es/components/link/link';

@Component({
  components: {
    FontAwesomeIcon,

    bButton,
    bCol,
    bContainer,
    bForm,
    bImg,
    bInput,
    bLink,
    bRow,
  },
})
export default class Footer extends Vue {
  public readonly faFacebookSquare = faFacebookSquare;
  public readonly faInstagram = faInstagram;
  public readonly faLine = faLine;

  public readonly menu = [
    {
      heading: '客戶服務',
      links: [
        {
          name: '商品退 / 換貨',
          url: '#',
        },
        {
          name: '配送說明',
          url: '#',
        },
        {
          name: '聯絡客服',
          url: '#',
        },
      ],
    },
    {
      heading: '關於雙喬嚴選',
      links: [
        {
          name: '關於我們',
          url: '#',
        },
        {
          name: '隱私權聲明',
          url: '#',
        },
        {
          name: '服務條款',
          url: '#',
        },
      ],
    },
  ];
}

